import React, { useContext, useState, useEffect } from 'react';
import TypeDescriber from '../TypeDescriber';
import Cards from '../cards/Cards';
import '../css/App.css';
import axios from 'axios';
import { CartContext } from '../cart/ContextProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from 'react-router-dom';
import Loader from '../common/Loader';
import MobileSearchBar from '../SearchBar/SearchBarMob';

function ClothRenderer(props) {
  const { category, initialLoading } = useContext(CartContext);
  const [clothes, setClothes] = useState([]);
  const [filteredClothes, setFilteredClothes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRanges, setSelectedRanges] = useState([]);
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  const type = props.link;


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    async function fetchClothes() {
      setLoading(true);
      setClothes([]);
      setSelectedRanges([])
      setFilteredClothes([])
      try {
        const response = await axios.get(`https://jackpotbackend.vercel.app${location.pathname}`);
        setClothes(response.data);
        setFilteredClothes(response.data); // Initialize filteredClothes with all clothes
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchClothes();
  }, [category, location.pathname]);




  function filterClothesByPriceRange() {
    if (selectedRanges.length === 0) {
      // If no range is selected, show all clothes
      setFilteredClothes(clothes);
    } else {
      // Filter clothes based on selected price ranges
      const filtered = clothes.filter(
        (item) =>
          selectedRanges.some(
            (range) => item.price >= range[0] && item.price <= range[1]
          )
      );
      setFilteredClothes(filtered);
    }
  };


  const handleCheckboxChange = (range) => {
    const index = selectedRanges.findIndex(
      (selectedRange) => selectedRange[0] === range[0]
    );

    if (index === -1) {
      // If not present, add to selectedRanges
      setSelectedRanges([...selectedRanges, range]);
    } else {
      // If present, remove from selectedRanges
      const updatedRanges = [...selectedRanges];
      updatedRanges.splice(index, 1);
      setSelectedRanges(updatedRanges);
    }
  };


  const clearFilters = () => {
    // Clear selected ranges and show all clothes
    setSelectedRanges([]);
    setFilteredClothes(clothes);
  };

  function toggleVisibility() {
    setIsVisible(!isVisible);
  };

  return (
    <div className='totalContent'>
      {loading || initialLoading ? (
        <Loader />
      ) : (
        <div className='totalClothContent'>

          <MobileSearchBar margin={"0 0 20px 0"} />

          <div className='typeDes'>
            <div className='typeDes-item'>
              <TypeDescriber location={location.pathname} />
            </div>
          </div>
          


          {/* price filter mobile view */}
          <div className='filter-div'>
            <div class="dropdown filter-dropdown">
              <button className='filter-dropdown-button' onClick={toggleVisibility}>Filter</button>
            </div>
            {isVisible && <div id="content"> <div className='priceWithHr-mob'>
              <div className='priceFilter'>

                <h5>
                  Price
                </h5>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 1000)}
                    onChange={() => handleCheckboxChange([1000, 2000])}
                  />
                  &nbsp;1000-2000
                </label>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 2000)}
                    onChange={() => handleCheckboxChange([2000, 3000])}
                  />
                  &nbsp;2000-3000
                </label>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 3000)}
                    onChange={() => handleCheckboxChange([3000, 4000])}
                  />
                  &nbsp;3000-4000
                </label>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 4000)}
                    onChange={() => handleCheckboxChange([4000, Infinity])}
                  />
                  &nbsp;Above 4000
                </label>
                <div className='buttonsInPrice'>
                  <button onClick={filterClothesByPriceRange}>Apply</button>
                  <button onClick={clearFilters}>Clear</button>
                </div>
              </div>
              {/* <hr /> */}
            </div> </div>}

          </div>




          <div className='all-content'>
            {/* Price Filter Section */}

            <div className='priceWithHr'>
              <div className='priceFilter'>
                <h3>
                  Filters
                </h3>

                <hr />
                <h5>
                  Price
                </h5>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 1000)}
                    onChange={() => handleCheckboxChange([1000, 2000])}
                  />
                  &nbsp;1000-2000
                </label>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 2000)}
                    onChange={() => handleCheckboxChange([2000, 3000])}
                  />
                  &nbsp;2000-3000
                </label>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 3000)}
                    onChange={() => handleCheckboxChange([3000, 4000])}
                  />
                  &nbsp;3000-4000
                </label>
                <label>
                  <input
                    type='checkbox'
                    checked={selectedRanges.some((range) => range[0] === 4000)}
                    onChange={() => handleCheckboxChange([4000, Infinity])}
                  />
                  &nbsp;Above 4000
                </label>
                <div className='buttonsInPrice'>
                  <button onClick={filterClothesByPriceRange}>Apply</button>
                  <button onClick={clearFilters}>Clear</button>
                </div>
              </div>
              {/* <hr /> */}
            </div>






            {/* Clothes Rendering */}
            {selectedRanges.length > 0 && filteredClothes.length === 0 ? (

              <div className='noItemsDiv'>
                <p>No items match the selected filter.</p>
              </div>

            ) : (
              <div className='content-item'>
                {filteredClothes.map((shirt, id) => (
                  <div key={id} className=''>
                    <Cards shirt={shirt} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ClothRenderer;